import { useNavigate } from 'react-router-dom';

import {
  gridSizeMdLg12,
  gridSizeMdLg6,
  // oltFormSchema,
  ROUTER_PATHS,
  useCheckPermissionsArray,
  // useLoaders,
  useMapComponent,
} from '@/shared';
import {
  CreateRadiusParams,
  useCreateRadius,
  useUpdateRadius,
} from '@/shared/actions/erp';
import {
  // CustomAutocomplete,
  CustomPasswordTextField,
  // CustomTextArea,
  CustomTextField,
  SingleFormBoxScene,
  SwitchComponenteForm,
  TabTextLabel,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { SAVE_RADIUS_PERMISSIONS } from '../../constants';
// import { useLocalidad } from '@/shared/hooks/useLocalidad';
import CustomCoordendasForm from '@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm';
import { RadiusExtended } from '@/shared/interfaces/erp/configuracion-red/radius';
import { radiusFormSchema } from '@/shared/utils/validation-schemas/erp/configuracion-red/radius.schema';


export interface SaveOLTComponentProps {
  title: string;
  radius?: RadiusExtended;
}

type SaveFormData = CreateRadiusParams & {
};

const SaveOLTComponent: React.FC<SaveOLTComponentProps> = ({ title, radius }) => {
  useCheckPermissionsArray(SAVE_RADIUS_PERMISSIONS);

  const returnUrlRadiusPage = ROUTER_PATHS.configuracionRED.radiusNav;
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(radiusFormSchema as any),
    defaultValues: {
      estado:true,
      // latitud: "0",
      // longitud: "0",
      coordenadas: radius?.coordenadas ?? '0,0'
    }
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = form;


  ///* store
  const setAlert = useUiStore(s => s.setAlert);


  // const watchedZona = form.watch('zona');
  const watchedCiudad = form.watch('ciudad');
  
  const {
    setLatLng,
    setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: watchedCiudad,
    distanciaNapKey: 'distancia_aproximada',
    coordenadasCliente: radius?.nodo_data?.coordenadas ?? '',
  });



  ///* mutations
  const createRadius = useCreateRadius({
    navigate,
    returnUrl: returnUrlRadiusPage,
  });
  const updateRadius = useUpdateRadius({
    navigate,
    returnUrl: returnUrlRadiusPage,
  });


  useEffect(() => {

    if (!radius) return;

    reset(radius)

    const coordenada = radius.coordenadas;

    if (!coordenada) return;

    setLatLng({
      lat: +coordenada.split(',')[0],
      lng: +coordenada.split(',')[1],
    })

    setCurrentCoordenadas(coordenada);

    return () => {

    }
  }, [radius])


  ///* handlers
  const onSave = async (data: SaveFormData) => {

    ///* update
    if (radius) {
      await updateRadius.mutateAsync({
        id: radius.id_radius!,
        data: {
          ...data,
        },
      });
      return;
    }

    ///* create
    await createRadius.mutateAsync(data);
  };



  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlRadiusPage)}
      onSave={handleSubmit(onSave, (errors) => {
        setAlert(true, 'Campos sin llenar', AlertSeverityEnum.error)
        console.log('errors', errors);
      })}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre}
        error={errors.nombre}
        helperText={errors.nombre?.message}
      // size={gridSizeMdLg6}
      />
      <CustomTextField
        label="Hostname"
        name="hostname"
        control={form.control}
        defaultValue={form.getValues().hostname}
        error={errors.hostname}
        helperText={errors.hostname?.message}
        size={gridSizeMdLg6}
        overrideAsPassword
      />
      <CustomPasswordTextField
        label="Password"
        name="password"
        errors={errors}
        form={form}
        size={gridSizeMdLg6}
      />

      <CustomTextField
        label="Dirección"
        name="direccion"
        control={form.control}
        defaultValue={form.getValues().direccion}
        error={errors.direccion}
        helperText={errors.direccion?.message}
        size={gridSizeMdLg6}
      />
      <SwitchComponenteForm
        label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
        size={gridSizeMdLg6}
        control={form.control}
        defaultValue={!!form.getValues()?.estado}
        name="estado"
      />


      <TabTextLabel text='Ubicación' mt={5}/>
      <CustomCoordendasForm
        form={form}
        label="Coordendas"
        name="coordenadas"
        defaultValue={form.watch().coordenadas}
        key={'key_bras_coordenadas'}
        size={gridSizeMdLg12}
        onlyValueLocation={true}
        enableLocationOnChange={false}
        handleDataUbicacion={(watchedCoordenadas) => {

          if (!watchedCoordenadas) return;

          setLatLng({
            lat: +watchedCoordenadas.split(',')[0],
            lng: +watchedCoordenadas.split(',')[1],
          })

          setCurrentCoordenadas(watchedCoordenadas);

        }}
      />


    </SingleFormBoxScene>
  );
};

export default SaveOLTComponent;
